import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LS } from 'src/app/helpers/localStorage.enum';
import { DataService } from 'src/app/services/data/data.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-card-large',
  templateUrl: './card-large.component.html',
  styleUrls: ['./card-large.component.sass']
})
export class CardLargeComponent implements OnInit {
  @Output() onClickClose: EventEmitter<boolean> = new EventEmitter()
  @Input() style: string
  @Input() closeURL: string
  @Input() title: string
  currentUser: any;
  logo: string;

  constructor(
    private navService: NavigationService,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dataService.localStorageSub$.subscribe(res => {
      if (Object.keys(res).length === 0 && res.constructor === Object) {
        this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser))
      } else if (res.key === LS.currentUser) {
        this.currentUser = res.data
      }
    })
    this.logo = this.currentUser.organisation?.logo_url
  }

  onClose() {
    this.onClickClose.emit(true)
  }

  closeButton() {
    if (this.closeURL) {
      this.router.navigateByUrl(this.closeURL)
    } else {
      this.navService.simulateClose()
    }
  }
}
